// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AddEditCategoryModal_mainWrapper__M+qEt","buttonsContainer":"AddEditCategoryModal_buttonsContainer__-5pBe"};